export default __webpack_public_path__ + "static/media/tree22.92a3b982.png";